// extracted by mini-css-extract-plugin
module.exports = {"typePrimary":"search-autocomplete-menu_typePrimary__ktb_D","sizeLg":"search-autocomplete-menu_sizeLg__P_iBd"};